import { CommonGet, CommonPost } from '../../helpers/HttpClient';

export default {
  getAllGroups,
  getFactoryByGroupID,
  getRoutesForDropDown,
  getAllRouteManagers,
  getRouteManagerDetailsFromID,
  saveRouteManagerDetails,
  DeleteRouteManager,
  UpdateRouteManagerDetails
};

async function getAllGroups() {
  let response = await CommonGet('/api/Group/GetAllGroups');
  let groupArray = [];
  for (let item of Object.entries(response.data)) {
    if (item[1]["isActive"] === true) {
      groupArray[item[1]["groupID"]] = item[1]["groupName"];
    }
  }
  return groupArray;
};

async function getFactoryByGroupID(groupID) {
  let response = await CommonGet('/api/Group/GetFactoryByGroupID', "groupID=" + parseInt(groupID));
  let factoryArray = [];
  for (let item of Object.entries(response.data)) {
    factoryArray[item[1]["factoryID"]] = item[1]["factoryName"];
  }
  return factoryArray;
};

async function getRoutesForDropDown(factoryID, groupID) {
  var routeArray = [];

  const response = await CommonGet('/api/Route/GetRoutesByFactoryIDAndGroupID', 'factoryID=' + factoryID + "&groupID=" + parseInt(groupID))
  for (let item of Object.entries(response.data)) {
    routeArray[item[1]["routeID"]] = item[1]["routeName"]
  }
  return routeArray;
}

async function getAllRouteManagers(model) {
  const response = await CommonGet('/api/RouteManager/GetRouteManagerDetails', "groupID=" + parseInt(model.groupID) + "&factoryID=" + parseInt(model.factoryID) + "&routeID=" + parseInt(model.routeID));
  return response;
}

async function getRouteManagerDetailsFromID(routeManagerID) {
  const response = await CommonGet('/api/routeManager/GetRouteManagerDetailsByID', "routeManagerID=" + routeManagerID);
  return response.data[0];
}

async function saveRouteManagerDetails(model) {
  const response = await CommonPost('/api/routeManager/SaveRouteManagerDetails', null, model);
  return response;
}

async function UpdateRouteManagerDetails(model) {

  const response = await CommonPost('/api/routeManager/UpdateRouteManagerDetails', null, model);
  return response;
}


async function DeleteRouteManager(routeManagerID, modifiedBy, modifiedDate) {
  const response = await CommonPost('/api/routeManager/DeleteRouteManagerDetails', "routeManagerID=" + parseInt(routeManagerID) + "&modifiedBy=" + parseInt(modifiedBy) + "&modifiedDate=" + modifiedDate);
  return response;
}
